import { AuthService } from '../services';

export const isModerator = () => {
  const roles = AuthService.getUserRoles();

  return roles.includes('MODERATOR');
};
